import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fe28c49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))

import { useRouter } from 'vue-router'
import { ElText } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const Login = () => {
  router.push({ name: 'signin' })
}

return (_ctx: any,_cache: any) => {
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElText), { class: "title" }, {
        default: _withCtx(() => [
          _createTextVNode("Manage BACnet Device Profiles For your BACnet Gateway")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ElButton, {
          id: "login",
          type: "primary",
          size: "large",
          onClick: Login
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Sign in with RAK ID ")
          ]),
          _: 1
        }),
        _createVNode(_unref(ElText), {
          style: {"width":"300px","margin-top":"40px"},
          size: "large"
        }, {
          default: _withCtx(() => [
            _createTextVNode("As WisDM is a part of RAK ecosystem you will create a single account, RAK ID. Find out more about RAK ID.")
          ]),
          _: 1
        })
      ]),
      _hoisted_4
    ]),
    _hoisted_5
  ]))
}
}

})